// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"c2f1bbb0","172":"f2ae8ee5","352":"ec201b10","412":"dd78958b","436":"10d48138","534":"5975404f","556":"880ac45a","592":"5587c8af","924":"7cc0cd08"}[chunkId] + ".chunk.js";
};